import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-error2',
  templateUrl: './error2.component.html',
  styleUrls: ['./error2.component.css']
})
export class Error2Component implements OnInit {
  code1: string = "<framework src='com.google.android.gms:play-services-base:15+' />";
  code2: string = "<framework src='com.google.android.gms:play-services-ads:15+' />"; 
  code3: string = "<framework src='com.google.android.gms:play-services-base:10+' />";
  code4: string = "<framework src='com.google.android.gms:play-services-ads:10+' />"; 
  code5:string = "<platform name='android'>";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/Errores/error2/error2.component.ts